import React, { Component } from 'react'
    
class GSoCFinalReport extends React.Component {
    componentDidMount() {
        window.location.replace("https://medium.com/@imsahil007/google-summer-of-code-21-final-report-fc964256d71b");
    }


    render() {
        return <div/>
    }
}


export default GSoCFinalReport